import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { bailiffJobDetailSelector } from "store/bailiff/bailiff/job/bailiff_job.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const FLOWS = {
  DEPOSIT: "waiting",
  //
  TRANSCRIPT: "transcript",
  SUPPORT: "support",
  //
  APPROVAL: "approval",
};

export const useJobDetailFlow = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [flow, setFlow] = useState(FLOWS.DEPOSIT);
  // -------------------------- REDUX ---------------------------
  const detail = useSelector(bailiffJobDetailSelector);
  const status = detail?.status || "waiting";

  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  useEffect(() => {
    if (status === "waiting" || status === "waiting for deposit") {
      setFlow(FLOWS.DEPOSIT);
    }
    if (status === "transcripting") {
      setFlow(FLOWS.TRANSCRIPT);
    }
    if (status === "support") {
      setFlow(FLOWS.SUPPORT);
    }
    if (status === "approval") {
      setFlow(FLOWS.APPROVAL);
    }
  }, [status]);
  // -------------------------- MAIN ----------------------------
  return { flow };
};
